/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Tooltip, TooltipTrigger, Button } from "react-aria-components";
import { InfoOutline } from "./core/icon/Icons";
import { tooltipCSS } from "./core/tooltip/styles";

interface InfoTooltipProps {
    content: string;
}

export function InfoTooltip({ content }: InfoTooltipProps) {
    return (
        <TooltipTrigger delay={200}>
            <Button
                css={css`
          background: transparent;
          border: none;
          padding: 2px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: help;
          color: var(--ac-global-text-color-400);
          opacity: 0.7;
          border-radius: 4px;
          transition: all 0.2s;
          & svg {
            fill: currentColor;
          }
          &:hover {
            opacity: 1;
            background: var(--ac-global-color-grey-200);
          }
        `}
            >
                <span css={css`width: 22px; height: 22px; display: flex;`}>
                    <InfoOutline />
                </span>
            </Button>
            <Tooltip css={tooltipCSS}>{content}</Tooltip>
        </TooltipTrigger>
    );
}
